import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { AuthService, Usuario } from '@sicapes/auth';
import { ToastrService } from 'ngx-toastr';
import { InscricaoService } from '../../../shared/service/inscricao/inscricao.service';
import { ParametrizacaoService } from '../../../shared/service/parametrizacao/parametrizacao.service';
import { ParticipanteService } from '../../../shared/service/inscricao/participante.service';
import { InstituicaoEnsinoService } from '../../../shared/service/corporativo/instituicao-ensino.service';
import { InstituicaoEnsinoModel } from '../../../shared/models/corporativo/instituicao-ensino.model';
import { BaseDashboardComponent } from '../base-dashboard.component';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import {CsabService} from '../../../shared/service/csab/csab.service';
import {ScpbService} from '../../../shared/service/scpb/scpb.service';
import {SucupiraService} from "../../../shared/service/sucupira/sucupira.service";
import {PessoaService} from "../../../shared/service/corporativo/pessoa.service";
import { LocalStorageService } from 'src/app/shared/service/local-storage.service';
import {RegraIniciarInscricao} from "../../../shared/service/inscricao/regra-iniciar-inscricao";

@Component({
    selector: 'app-dashboard-aba-aberta',
    templateUrl: './dashboard-aba-aberta.component.html',
    styleUrls: ['./dashboard-aba-aberta.component.css']
})
export class DashboardAbaAbertaComponent extends BaseDashboardComponent implements OnInit {

    @ViewChild('fileUpload') fileUploadInput: ElementRef<HTMLInputElement>;

    @Input() rows: any[] = [];
    @Input() inscricoes: any;
    @Output() inscricaoEvent = new EventEmitter<any>();

    currentUser: any;
    visible: boolean;
    exibirMensagem: boolean = false;
    mensagem: string = '';

    intituicoesEnsino: InstituicaoEnsinoModel[];
    rowsMemory: any[] = [];
    modalidadeBolsaAbertas: any[];
    programaCapesAbertas: any[];
    contentFile: any;
    fileUpload: any;
    parametrizacao: any;
    tiposParametrizacaoAbertas: any[] = [
        { descricao: 'Auxílio', tipo: 'A' },
        { descricao: 'Bolsa', tipo: 'I' },
        { descricao: 'Projeto', tipo: 'P' },
    ];
    tiposFuncaoSolicitarAcesso: any[] = [
        { descricao: 'Coordenador de Programa', id: 80 },
        { descricao: 'Pró-reitor', id: 42 },
        { descricao: 'Representante Institucional', id: 43 },
    ];
    filter: any = {
        tipo: null,
        modalidade: null,
        programa: null
    };
    solicitacaoAcessoForm = this.formBuilder.group({
        nome: [{ value: null, disabled: false }, [Validators.required]],
        ies: [{ value: null, disabled: false }, [Validators.required]],
        funcao: [{ value: null, disabled: false }, [Validators.required]],
        contentFile: [{ value: null, disabled: false }, [Validators.required]],
    });

    constructor(protected parametrizacaoService: ParametrizacaoService,
        protected participanteService: ParticipanteService,
        protected inscricaoService: InscricaoService,
        protected csabService: CsabService,
        protected scpbService: ScpbService,
        protected sucupiraService: SucupiraService,
        protected pessoaService: PessoaService,
        protected instituicaoEnsinoService: InstituicaoEnsinoService,
        protected regraIniciarInscricao: RegraIniciarInscricao,
        protected confirmationService: ConfirmationService,
        protected toastr: ToastrService,
        protected localStorageService: LocalStorageService,
        public authService: AuthService,
        protected router: Router,
        private formBuilder: FormBuilder) {
        super(parametrizacaoService, participanteService, inscricaoService, confirmationService, toastr);
        this.authService.currentUser.subscribe((x: any) => this.currentUser = x);
    }

    ngOnInit(): void {
        this.rowsMemory = this.rows;
        this.obterListaFiltro();
        this.exibirMensagem = false;
        this.mensagem = '';
    }

    async iniciarInscricao(parametrizacao: any) {
        if(await this.regraIniciarInscricao.validateInscricaoStart(parametrizacao)) {
            this.iniciar(parametrizacao);
        } else {
            // TODO: mostrar mensagem de erro
            this.exibirMensagem = true;
            this.mensagem = this.localStorageService.get('mensagemErroIniciarInscricao');
            return;
        }
    }

    iniciar(parametrizacao: any): void {
        // removendo o id da parametrizacao para evitar um PUT:
        parametrizacao.id = null;
        this.inscricaoService.iniciarInscricao(parametrizacao).subscribe(
            (inscricao: any) => {
                // faço reload e faço o sistema expandir a nova inscriçao
                // @TODO: comentei, nao tem pq dar reload na pagina, sendo que ele é redirecionado para formulário dados pessoais
                // this.inscricaoEvent.emit(inscricao.codigo);

                // Redirect para dados pessoais
                const formulariosDadosPessoaisEsp: string[] = [
                    'inscricao-dados-pessoais',
                    'inscricao-dados-pessoais-brasileiros',
                    'inscricao-dados-pessoais-completos',
                    'inscricao-dados-pessoais-completos-dri',
                    'inscricao-dados-pessoais-dpb',
                    'inscricao-dados-pessoais-unico',
                ];
                const formularioDadosPessoais: any[] = inscricao.formularios.filter((f) => {
                    return formulariosDadosPessoaisEsp.indexOf(f.formulario_parametrizado.tipo.sigla) > -1;
                });
                if (formularioDadosPessoais.length > 0) {
                    this.router.navigate(['/inscricao', inscricao.proponente.codigo, inscricao.codigo, formularioDadosPessoais[0].formulario_parametrizado.tipo.sigla]);
                }
            },
            (error: any) => {
                this.toastr.error('Erro ao criar uma nova inscrição.');
            }
        );
    }

    isInscricaoEmPreenchimento(parametrizacao: any): boolean {
        const inscricoes: any[] = this.inscricoes.emPreenchimento;

        if (inscricoes === null || inscricoes === undefined || inscricoes.length === undefined) {
            return false;
        }

        return inscricoes.some(x => x.sg_edital === parametrizacao.sg_edital);
    }

    public obterListaFiltro(): void {
        this.modalidadeBolsaAbertas = Array.from(new Set(this.rows.map(a => a.modalidade)))
            .map(modalidade => {
                return this.rows.find(a => a.modalidade === modalidade);
            }
        );

        this.programaCapesAbertas = Array.from(new Set(this.rows.map(a => a.nm_programa_capes)))
            .map(nmProgramaCapes => {
                return this.rows.find(a => a.nm_programa_capes === nmProgramaCapes);
            }
        );
    }

    public filterLista(tipo): void {
        this.rows = this.rowsMemory;

        if (tipo === 'tipo') {
            this.filter.modalidade = null;
            this.filter.programa = null;
            if (this.filter.tipo !== null) {
                this.rows = this.rows.filter((row) => row.tp_parametro_edital === this.filter.tipo.tipo);
            }
        }

        if (tipo === 'modalidade') {
            this.filter.tipo = null;
            this.filter.programa = null;
            if (this.filter.modalidade !== null) {
                this.rows = this.rows.filter((row) => row.modalidade === this.filter.modalidade.modalidade);
            }
        }

        if (tipo === 'programa') {
            this.filter.modalidade = null;
            this.filter.tipo = null;
            if (this.filter.programa !== null) {
                this.rows = this.rows.filter((row) => row.nm_programa_capes === this.filter.programa.nm_programa_capes);
            }
        }
    }

    openModalSolicitarAcesso(parametrizacao: any): void {
        this.contentFile = null;
        this.fileUpload = null;
        this.solicitacaoAcessoForm.reset();
        this.solicitacaoAcessoForm.get('nome').setValue(this.currentUser.corporativo.nome);
        this.resetFileInput();
        this.visible = true;
        this.parametrizacao = parametrizacao;
    }

    private resetFileInput(): void {
        if (this.fileUploadInput?.nativeElement) {
            this.fileUploadInput.nativeElement.value = '';
        }
    }

    enviarSolicitacaoAcesso(dados: any): void {
        this.visible = false;
    }

    public filterInstituicoesEnsino(e: any): void {
        this.instituicaoEnsinoService.getInstituicoesBrasileiras(e.query).subscribe(
            ies => {
                this.intituicoesEnsino = ies;
            },
            error => this.toastr.error(error.error.detail)
        );
    }

    public onFileSelected(event): void {
        const input = event.target as HTMLInputElement;
        const file: File = input.files && input.files[0];
        const contentFileControl = this.solicitacaoAcessoForm.get('contentFile');

        this.contentFile = null;
        this.fileUpload = null;
        contentFileControl.setValue(null);
        contentFileControl.markAsTouched();

        if (!file) {
            contentFileControl.updateValueAndValidity();
            return;
        }

        const reader: FileReader = new FileReader();
        reader.readAsDataURL(file);
        const toastr = this.toastr;

        reader.onload = () => {
            const fileContent = reader.result;

            if (typeof fileContent === 'string') {
                const pdfTest = fileContent.substr(0, 20);
                if (pdfTest !== 'data:application/pdf') {
                    toastr.error('Arquivo corrompido ou não compatível com o formato PDF');
                    input.value = '';
                    contentFileControl.updateValueAndValidity();
                    return;
                }
            }

            if (file.name.length > 100) {
                toastr.error('O nome do arquivo possui tamanho maior que 100 caracteres.');
                input.value = '';
                contentFileControl.updateValueAndValidity();
                return;
            }

            this.contentFile = fileContent;
            this.fileUpload = file;
            // Controle só guarda o nome do arquivo (input file não aceita File via formControl).
            contentFileControl.setValue(file.name);
            contentFileControl.updateValueAndValidity();
        };
    }

    onSubmit(): void {
        if (this.solicitacaoAcessoForm.invalid) {
            this.solicitacaoAcessoForm.markAllAsTouched();
            return;
        }

        console.warn('Your order has been submitted', this.solicitacaoAcessoForm.value);
        const siglaEdital = this.parametrizacao.sg_edital;
        const usuario = { id: this.currentUser.corporativo.id, nome: this.currentUser.corporativo.nome, codigo: this.currentUser.corporativo.codigo };
        const instituicao = { id: this.solicitacaoAcessoForm.get('ies').value.id, nome: this.solicitacaoAcessoForm.get('ies').value.nome, sigla: this.solicitacaoAcessoForm.get('ies').value.sigla };
        const funcao = this.solicitacaoAcessoForm.get('funcao').value;
        const situacao = { tipo: 'P', descricao: 'Pendente' };
        const arquivoDoc = this.prepareDoc();

        this.parametrizacaoService.salvarSolicitacaoAcesso(siglaEdital, usuario, instituicao, funcao, situacao, arquivoDoc).subscribe(
            acesso => {
                this.parametrizacao.cs_situacao_acesso = acesso.body.situacao_acesso;
                this.parametrizacao.dt_solicitacao_acesso = moment(acesso.body.ultima_alteracao, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss');
                this.toastr.success('Solicitação enviada com sucesso!');
                this.visible = false;
                this.contentFile = null;
                this.fileUpload = null;
                this.solicitacaoAcessoForm.reset();
                this.resetFileInput();
            },
            error => this.toastr.error('Não foi possível enviar a solicitação de acesso.')
        );
    }

    private prepareDoc(): any {

        const body = {
            type: 'application/pdf',
            content: this.contentFile,
            nome: this.fileUpload.name,
        };

        return body;
    }

    public permiteAcesso(parametrizacao): boolean {
        let dt_limite_solicitacao = moment(parametrizacao.dt_fim_acesso);
        let agora = moment();
        if (dt_limite_solicitacao.isBefore(agora)) {
            return false;
        }
        if (parametrizacao.cs_situacao_acesso == 'I' || parametrizacao.cs_situacao_acesso == 'A') {
            return false;
        }
        if (parametrizacao.dt_inicio_acesso && parametrizacao.cs_situacao_acesso != 'P') {
            return true;
        }
        return false;
    }

    public permiteIniciarInscricao(parametrizacao): boolean {
        let dt_inicio_inscricao = moment(parametrizacao.dt_inicio_fase);
        let agora = moment();
        if (parametrizacao.cs_situacao_acesso == 'I' || dt_inicio_inscricao.isAfter(agora)) {
            return false;
        }
        if (!parametrizacao.dt_inicio_acesso || (parametrizacao.dt_inicio_acesso && parametrizacao.cs_situacao_acesso != 'P' && parametrizacao.cs_situacao_acesso != null)) {
            return true;
        }
        return false;
    }

    public dataMaiorQueHoje(data_comparacao): boolean {
        let agora = moment();
        return moment(data_comparacao).isAfter(agora);
    }

    public getTipoEdital(parametrizacao: any): string {
        if (parametrizacao.sg_programa_capes === 'MOVE' || parametrizacao.sg_programa_capes === 'PDAI') {
            return '';
        } else {
            return parametrizacao.sg_programa_capes === 'POA-2026'
                ? 'CHAMAMENTO PÚBLICO - '
                : parametrizacao.tp_parametro_edital === 'I'
                    ? 'Bolsa Individual - '
                    : parametrizacao.tp_parametro_edital === 'P'
                        ? 'Projeto - '
                        : 'Auxílio - ';
        }
    }
}
